import React, { useEffect, useState } from "react";
import apiUrl from "../../Apiurl";
import axios from "axios";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import ProdottoSincronizzato from "./ProdottoSincronizzato";

function SyncImmagini({ utente, token }) {
  const [input, setInput] = useState({
    id_brand: null,
    year: null,
    limit: 50,
    reference: null,
  });

  const [loading, setLoading] = useState(false);
  const [mostraLogs, setMostraLogs] = useState(false);
  const [risultato, setRisultato] = useState(false);
  const [message, setMessage] = useState(false);
  const [classeRisultato, setClasseRisultato] = useState(
    "sfondoBiancoTema b--white"
  );

  function elaboraRisultati(log) {
    return Object.entries(log).map(([codice, dati]) => {
      // caso: il valore è un array di messaggi di errore
      if (Array.isArray(dati)) {
        return {
          codice,
          immagini: [],
          archiviato: false,
          errore: dati,
        };
      }

      // caso normale: dati è un oggetto
      const immagini = dati?.id_images
        ? Object.entries(dati.id_images).map(([numero, id]) => ({ numero, id }))
        : [];

      const archiviato = dati?.archived ?? false;

      // eventuali messaggi di errore presenti nelle proprietà comuni
      const errore = dati?.message ?? dati?.error ?? dati?.errors ?? null;

      const result = { codice, immagini, archiviato };
      if (errore) result.errore = errore;

      return result;
    });
  }

  const richiediSync = async () => {
    // Rimuove i valori null da input
    const inputPulito = Object.fromEntries(
      Object.entries(input).filter(([_, v]) => v !== null && v !== "")
    );
    const nuoviParams = new URLSearchParams(inputPulito);
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    setRisultato(false);
    setLoading(true);
    try {
      const response = await axios.get(
        apiUrl + "/prodotti/ps/syncImmagini?" + nuoviParams,
        config
      );
      setLoading(false);
      setRisultato(response.data);
      if (response.data.message) {
        setMessage(response.data.message);
      }
      if (response.data["status"] === "OK") {
        setClasseRisultato("sfondoBiancoTema");
      } else {
        setClasseRisultato("colPreparazione");
      }
    } catch (error) {
      setRisultato(error);
      setClasseRisultato("colAnnullato");
      if (error.message) {
        setMessage(error.message);
      }
    }
  };

  const form = (
    <div className="b--white">
      <h3>SYNC IMMAGINI</h3>
      <div className="">
        Sincronizza le immagini in questa cartella:
        <input
          type="text"
          className={stilePulsanti.inputClassesConTasto + " mt2"}
          value={input.id_brand || ""}
          onChange={(e) => setInput({ ...input, id_brand: e.target.value })}
          placeholder="(ID brand Moda)"
          autoComplete="off"
        />
      </div>
      <div className="">
        nella sottocartella di questo anno:
        <input
          type="text"
          className={stilePulsanti.inputClassesConTasto + " mt2"}
          value={input.year || ""}
          onChange={(e) => setInput({ ...input, year: e.target.value })}
          placeholder="(anno cartella)"
          autoComplete="off"
        />
      </div>
      <div className="">
        (opzionale) sincronizza SOLO questo codice specifico:
        <input
          type="text"
          className={stilePulsanti.inputClassesConTasto + " mt2"}
          value={input.reference || ""}
          onChange={(e) => setInput({ ...input, reference: e.target.value })}
          placeholder="(codice raggruppativo)"
          autoComplete="off"
        />
      </div>
      <div className="">
        Limita l'elaborazione a tot. codici:
        <input
          type="number"
          className={stilePulsanti.inputClassesConTasto + " mt2"}
          value={input.limit || ""}
          onChange={(e) => setInput({ ...input, limit: e.target.value })}
        />
      </div>
      <br />
      <div className="flex">
        <div className="mb3">
          Prima carica le immagini nella cartella SFTP. Le immagini devono
          essere 1000*1000*72, in formato jpg, in struttura di cartelle [ID
          BRAND MODA]/[ANNO]/[CODICE PROGRESSIVO]/codiceprogressivo-1.jpg,
          codiceprogressivo-2.jpg ecc
        </div>
      </div>
    </div>
  );

  return (
    <div className="colonnaTuttaPagina">
      <div className="pa5 flex items-start justify-center">
        <section className="w-third sfondoBiancoTema br4 mr3 shadow-4 ph3 ph5-ns pv5 b--white">
          <article className="center br2 ba b--white">{form}</article>
          <div className="mt4 tc">
            <button
              className={stilePulsanti.buttonClassesWhite}
              onClick={richiediSync}
            >
              <div className="f4">SYNC</div>
            </button>
          </div>
        </section>
        {!risultato && !loading && (
          <section className="w-50 br4 ph3 ph5-ns pv5"></section>
        )}
        {loading && (
          <section className="w-50 br4 ph3 ph5-ns pv5">Caricamento...</section>
        )}
        {risultato && (
          <section
            className={
              classeRisultato +
              " w-50 br4 shadow-4 ph3 ph5-ns pv5 colonna80vh sezioneConScroll"
            }
          >
            {risultato["status"] === "OK" && <h2>Risultato sync</h2>}
            {risultato["status"] === "OK" && (
              <p>
                le immagini dei seguenti articoli sono state sincronizzate
                correttamente. Puoi cancellare i file corrispondenti da
                filezilla.
              </p>
            )}
            {risultato["status"] === "OK" && (
              <p>
                ATTENZIONE: se un articolo nella cartella indicata non è stato
                sincronizzato non apparirà in questa lista. Non sono stati
                ancora implementati messaggi di errore.
              </p>
            )}
            {risultato["status"] === "OK" && (
              <div className="flex flex-wrap">
                {risultato.data.log &&
                  elaboraRisultati(risultato.data.log).map((articolo) => (
                    <ProdottoSincronizzato articolo={articolo} />
                  ))}
                {!risultato.data.log && (
                  <div>
                    <h3>Nessuna immagine sincronizzata.</h3>
                  </div>
                )}
              </div>
            )}
            {risultato["status"] === "WARNING" && (
              <div className="colAnnullato pa2">
                {risultato.message && <p>{risultato.message}</p>}
              </div>
            )}
            <button
              className={stilePulsanti.buttonClassesWhite}
              onClick={() => setMostraLogs(!mostraLogs)}
            >
              Mostra/nascondi logs
            </button>
            {mostraLogs && <pre>{JSON.stringify(risultato, null, 2)}</pre>}
          </section>
        )}
      </div>
    </div>
  );
}

export default SyncImmagini;
